import { InvoiceMatterDetailsDto } from 'types/invoices';
import { InvoiceExpensesCard } from '../views/details-tab/invoice-expenses/InvoiceExpensesCard';
import { byCaseNumber } from './invoiceSections';
import { InvoiceTabProps } from './invoiceTabProps';
import { InvoiceVariantNotice } from './InvoiceVariantNotice';
import { CaseItemsVeil, useCaseItemsCard, useTabAlerts } from './TimecardsTab';

function CaseExpenses({ invoiceMatter, ...props }: InvoiceTabProps & { invoiceMatter: InvoiceMatterDetailsDto }) {
    const card = useCaseItemsCard(props, invoiceMatter);
    if (!card) return null;
    const { isMatterSummaryFetching, ...cardProps } = card;
    return (
        <CaseItemsVeil invoiceId={props.invoice.id} isFetching={isMatterSummaryFetching}>
            <InvoiceExpensesCard
                {...cardProps}
                addedInvoiceExpenseIds={props.addedInvoiceExpenseIds}
                setAddedInvoiceExpenseIds={props.setAddedInvoiceExpenseIds}
                isLoading={props.isLoading || props.addNewInvoiceItems.isAddingNewExpenses}
            />
        </CaseItemsVeil>
    );
}

/**
 * The Expenses tab of the new design: a credit note's or a correction's notice, its alerts, then each case's Expenses
 * card by case number.
 */
export function ExpensesTab(props: InvoiceTabProps) {
    const { alertList } = useTabAlerts(props);
    return (
        <>
            <InvoiceVariantNotice invoice={props.invoice} />
            {alertList}
            {(props.invoice.invoiceMatters ?? []).toSorted(byCaseNumber).map((invoiceMatter) => (
                <CaseExpenses key={invoiceMatter.matterId} {...props} invoiceMatter={invoiceMatter} />
            ))}
        </>
    );
}
